export const JOB_COLOR_PALETTE = [
  '#0f766e',
  '#475569',
  '#4338ca',
  '#78350f',
  '#a21caf',
  '#4d7c0f',
  '#155e75',
  '#1f2937',
  '#3730a3',
  '#854d0e',
  '#86198f',
  '#3f6212',
] as const;

export function getJobColor(jobId: number): string {
  let hash = 0;
  const value = String(jobId);
  for (let index = 0; index < value.length; index++) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
  }
  return JOB_COLOR_PALETTE[hash % JOB_COLOR_PALETTE.length];
}
